module.exports = __webpack_public_path__ + "static/media/team4.35f003ab.jpg";